var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.status.processing)?_c('p',[_vm._v(_vm._s(_vm.$t('publisher.gc.cat.enc.processing')))]):_vm._e(),_c('router-view',{attrs:{"name":"encView"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }